import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

const axiosInstance = axios.create({
  baseURL, // Ensure this is just the root URL without `/api`
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Ensures cookies are included in requests
});

/**
 * Request Interceptor: Attach token unless it's a public shared route.
 */
axiosInstance.interceptors.request.use(
  (config) => {
    const publicSharedRouteRegex = /^\/surveys\/shared\/[^/]+(\/comments)?$/;

    if (!publicSharedRouteRegex.test(config.url)) {
      // Retrieve token from localStorage
      const token = localStorage.getItem("token");

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        console.debug("Axios: Attached Authorization header:", config.headers["Authorization"]);
      } else if (!token) {
        console.warn("Axios: No token found in localStorage. Authorization header not set.");
      }
    } else {
      console.debug("Axios: Public shared route detected. Authorization header not attached.");
    }

    console.debug("Axios: Request details:", {
      url: config.url,
      method: config.method,
      headers: config.headers,
    });

    return config;
  },
  (error) => {
    console.error("Axios: Request error:", error.message || error);
    return Promise.reject(error);
  }
);

/**
 * Response Interceptor: Handle errors globally.
 */
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error("Axios: API Error:", error.response.data.message || error.message);

      if (error.response.status === 401) {
        if (error.response.data.reason === "expired") {
          console.warn("Axios: Token expired. Consider implementing a refresh token logic.");
          // Refresh token logic could go here if supported
        } else {
          console.warn("Axios: Unauthorized. Logging out...");
          localStorage.removeItem("token");
          delete axiosInstance.defaults.headers.common["Authorization"];
          window.location.href = "/login";
        }
      }
    } else if (error.request) {
      console.error("Axios: No response received:", error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
